import { combineReducers } from '@reduxjs/toolkit';
import api from '../api/api';

// reducers
import amlDictionariesReducer from './dictionaries/slices';

// BLACKLIST
import blacklistReducer from '../hoc/blacklist/store/slices/list';
import blacklistUserInfoReducer from '../hoc/blacklist/store/slices/user';
import blacklistCreateReducer from '../hoc/blacklist/store/slices/create';
import blacklistPageReducer from '../hoc/blacklist/store/slices/item';

// SETTINGS
import riskLevelsListReducer from '../hoc/risk-levels/store/slices/list';
import riskLevelsFormReducer from '../hoc/risk-levels/store/slices/form';

// GEOGRAPHICAL
import geogrpahicalRiskReducer from '../hoc/geographical/store/slices/geographical';

// TRANSATION MONITORING RULES
import transactionMonitoringRulesReducer from '../hoc/transaction-monitoring-rules/store/slices/list';
import transactionMonitoringRuleFormReducer from '../hoc/transaction-monitoring-rules/store/slices/form';

// TRANSACTIONS RISK
import transactionsVolumeRiskListReducer from '../hoc/transactions-risk/store/slices/volume-risk-list';
import transactionsVolumeRiskFormReducer from '../hoc/transactions-risk/store/slices/volume-risk-form';
import transactionsTypesRiskReducer from '../hoc/transactions-risk/store/slices/types-risk';

// INDIVIDUAL CLIENTS RISK
import individualClientsRiskVolumesListReducer from '../hoc/indiviual-clients-risk/store/slices/volumes-list';
import individualClientsRiskVolumesFormStateReducer from '../hoc/indiviual-clients-risk/store/slices/volumes-form';
import individualClientsProductsListReducer from '../hoc/indiviual-clients-risk/store/slices/products-list';
import individualClientsProductsItemReducer from '../hoc/indiviual-clients-risk/store/slices/products-form';
import individualClientsDeliveryChannelsReducer from '../hoc/indiviual-clients-risk/store/slices/delivery-channels-list';
import individualClientsDeliveryChannelsFormReducer from '../hoc/indiviual-clients-risk/store/slices/delivery-channels-form';
import individualClientsActivitiesListReducer from '../hoc/indiviual-clients-risk/store/slices/client-activity-list';
import individualClientsActivitiesFormReducer from '../hoc/indiviual-clients-risk/store/slices/client-activity-form';
import individualClientsSourceOfFundsListReducer from '../hoc/indiviual-clients-risk/store/slices/source-of-funds-list';
import individualClientsSourceOfFundsFormReducer from '../hoc/indiviual-clients-risk/store/slices/source-of-funds-form';

// CORPORATE CLIENTS RISK
import corporateClientsIncorporationDatesListReducer from '../hoc/corporate-clients-risk/store/slices/incorporation-dates-list';
import corporateClientsIncorporationDatesFormReducer from '../hoc/corporate-clients-risk/store/slices/incorporation-dates-form';
import corporateClientsSicCodesReducer from '../hoc/corporate-clients-risk/store/slices/sic-codes';
import corporateClientsRiskVolumesListReducer from '../hoc/corporate-clients-risk/store/slices/volumes-list';
import corporateClientsRiskVolumesFormReducer from '../hoc/corporate-clients-risk/store/slices/volumes-form';
import corporateClientsProductsListReducer from '../hoc/corporate-clients-risk/store/slices/products-list';
import corporateClientsProductsFormReducer from '../hoc/corporate-clients-risk/store/slices/products-form';
import corporateClientsDeliveryChannelsListReducer from '../hoc/corporate-clients-risk/store/slices/delivery-channels-list';
import corporateClientsDeliveryChannelsFormReducer from '../hoc/corporate-clients-risk/store/slices/delivery-channels-form';

// middlewares
// SETTINGS
import riskScoreMiddlewares from './middlewares';

export const amlKycReducers = {
  amlApi: api.reducer,
  amlDictionaries: amlDictionariesReducer,
  blacklist: combineReducers({
    list: blacklistReducer,
    info: blacklistUserInfoReducer,
    create: blacklistCreateReducer,
    item: blacklistPageReducer,
  }),
  riskLevels: combineReducers({
    list: riskLevelsListReducer,
    form: riskLevelsFormReducer,
  }),
  geographical: geogrpahicalRiskReducer,
  transactionMonitoringRules: combineReducers({
    list: transactionMonitoringRulesReducer,
    form: transactionMonitoringRuleFormReducer,
  }),

  transactionsRisk: combineReducers({
    volumesRisk: combineReducers({
      list: transactionsVolumeRiskListReducer,
      form: transactionsVolumeRiskFormReducer,
    }),
    typesRisk: transactionsTypesRiskReducer,
  }),
  individualClientsRisk: combineReducers({
    volumes: combineReducers({
      list: individualClientsRiskVolumesListReducer,
      form: individualClientsRiskVolumesFormStateReducer,
    }),
    products: combineReducers({
      list: individualClientsProductsListReducer,
      form: individualClientsProductsItemReducer,
    }),
    deliveryChannels: combineReducers({
      list: individualClientsDeliveryChannelsReducer,
      form: individualClientsDeliveryChannelsFormReducer,
    }),
    clientActivity: combineReducers({
      list: individualClientsActivitiesListReducer,
      form: individualClientsActivitiesFormReducer,
    }),
    sourceOfFunds: combineReducers({
      list: individualClientsSourceOfFundsListReducer,
      form: individualClientsSourceOfFundsFormReducer,
    }),
  }),
  corporateClientsRisk: combineReducers({
    incorporationDates: combineReducers({
      list: corporateClientsIncorporationDatesListReducer,
      form: corporateClientsIncorporationDatesFormReducer,
    }),
    sicCodes: corporateClientsSicCodesReducer,
    volumes: combineReducers({
      list: corporateClientsRiskVolumesListReducer,
      form: corporateClientsRiskVolumesFormReducer,
    }),
    products: combineReducers({
      list: corporateClientsProductsListReducer,
      form: corporateClientsProductsFormReducer,
    }),
    deliveryChannels: combineReducers({
      list: corporateClientsDeliveryChannelsListReducer,
      form: corporateClientsDeliveryChannelsFormReducer,
    }),
  }),
};

export const amlApi = [api.middleware, riskScoreMiddlewares.middleware];
